import React from "react";
import { Link } from "react-router-dom";
import SEO from "./SEO";

const TermsOfService = () => {
  return (
    <div className="terms-page">
      <SEO
        title="Terms of Service | Tax Advocate Group"
        description="Read the Terms of Service for Tax Advocate Group. Understand your rights and obligations when using our tax resolution and consulting services."
        canonical="/terms-of-service"
        noindex={true}
      />
      {/* Hero Section */}
      <section className="terms-hero">
        <div className="terms-hero-overlay"></div>
        <div className="terms-hero-content">
          <h1>Terms of Service</h1>
          <nav className="terms-breadcrumbs">
            <Link to="/">Home</Link> <span>/</span>{" "}
            <span>Terms of Service</span>
          </nav>
        </div>
      </section>

      {/* Terms Content */}
      <div className="terms-content">
        <h2>Terms</h2>
        <p>
          By accessing the website at{" "}
          <a
            href="https://www.taxadvocategroup.com/"
            target="_blank"
            rel="noopener noreferrer"
          >
            taxadvocategroup.com
          </a>
          , you agree to be bound by these terms of service, all applicable
          laws, and regulations, and acknowledge that you are responsible for
          compliance with applicable local laws. If you do not agree, you are
          prohibited from using or accessing this site. The materials on this
          website are protected by applicable copyright and trademark laws.
        </p>

        <h2>Use of License</h2>
        <p>
          Permission is granted to temporarily download one copy of the
          materials (information or software) on Tax Advocate Group's website
          for personal, non-commercial transitory viewing only.
        </p>
        <p>This license does not permit you to:</p>
        <ul>
          <li>Modify or copy the materials</li>
          <li>
            Use the materials for any commercial purpose or public display
          </li>
          <li>Attempt to decompile or reverse engineer any website software</li>
          <li>Remove copyright or other proprietary notices</li>
          <li>Transfer materials or mirror them on another server</li>
        </ul>
        <p>
          This license shall automatically terminate if you violate any of these
          restrictions and may be terminated by Tax Advocate Group at any time.
        </p>

        <h2>Disclaimer</h2>
        <p>
          The materials on this website are provided "as is." Tax Advocate Group
          makes no warranties, expressed or implied, and disclaims all other
          warranties, including but not limited to merchantability, fitness for
          a particular purpose, or non-infringement.
        </p>

        <h2>Limitations</h2>
        <p>
          In no event shall Tax Advocate Group or its suppliers be liable for
          any damages (including, but not limited to, loss of data or profit)
          arising out of the use or inability to use materials on this website.
        </p>

        <h2>Restrictions</h2>
        <p>You are specifically restricted from:</p>
        <ul>
          <li>Publishing website material in any media</li>
          <li>Selling or sublicensing website material</li>
          <li>Publicly performing and/or showing website material</li>
          <li>Using this website in a damaging or unlawful way</li>
          <li>Engaging in data mining, harvesting, or extraction</li>
          <li>Using this website for advertising or marketing</li>
        </ul>
        <p>
          Certain areas of this website are restricted, and Tax Advocate Group
          may further restrict access at its discretion.
        </p>

        <h2>Accuracy of Materials</h2>
        <p>
          The materials on this website may include technical, typographical, or
          photographic errors. Tax Advocate Group does not guarantee that
          materials on the site are accurate or current.
        </p>

        <h2>Links</h2>
        <p>
          Tax Advocate Group is not responsible for the content of any linked
          site. The inclusion of any link does not imply endorsement.
        </p>

        <h2>Modifications</h2>
        <p>
          Tax Advocate Group may revise these terms of service at any time
          without notice. By using this website, you agree to be bound by the
          current version of these terms.
        </p>

        <h2>Governing Law</h2>
        <p>
          These terms are governed by California law, and you submit to the
          jurisdiction of courts in California for dispute resolution.
        </p>

        <h2>Intellectual Property Rights</h2>
        <p>
          Other than content you own, Tax Advocate Group and its licensors own
          all intellectual property rights in this website. You are granted a
          limited license only for viewing the material.
        </p>

        <h2>Your Content</h2>
        <p>
          By displaying your content on this website, you grant Tax Advocate
          Group a non-exclusive, worldwide, irrevocable license to use,
          reproduce, publish, and distribute it.
        </p>
        <p>
          Your content must not be defamatory, infringe on third-party rights,
          or violate laws.
        </p>

        <h2>No Warranties</h2>
        <p>
          This website is provided "as is," and Tax Advocate Group makes no
          representations or warranties of any kind related to this website.
        </p>

        <h2>Limitation of Liability</h2>
        <p>
          Tax Advocate Group, its officers, and employees shall not be held
          liable for any damages related to your use of this website.
        </p>

        <h2>Indemnification</h2>
        <p>
          You agree to indemnify Tax Advocate Group against any liabilities,
          damages, or expenses arising from your breach of these terms.
        </p>

        <h2>Severability</h2>
        <p>
          If any provision is found to be invalid, it shall be deleted without
          affecting the remaining provisions.
        </p>

        <h2>Assignment</h2>
        <p>
          Tax Advocate Group may assign or subcontract its rights without
          notice, but you may not transfer your rights under these terms.
        </p>

        <h2>Entire Agreement</h2>
        <p>
          These terms constitute the entire agreement between you and Tax
          Advocate Group.
        </p>

        {/* ═══════════════════════════════════════════════════════════════
         *  SMS COMMUNICATIONS — Required by TCR Registration
         * ═══════════════════════════════════════════════════════════════ */}
        <h2>SMS Communications</h2>

        <h3>1. SMS Consent Communication</h3>
        <p>
          The information (including phone numbers) obtained as part of the SMS
          consent process will not be shared with third parties for their own
          marketing purposes under any circumstances.
        </p>

        <h3>2. Types of SMS Communications</h3>
        <p>
          If you have consented to receive text messages from Tax Advocate
          Group, you may receive messages related to the following:
        </p>
        <ul>
          <li>
            <strong>Customer Care</strong> — Examples include case status
            updates, document requests, appointment reminders, and scheduled
            payment notifications.
          </li>
        </ul>
        <p>
          Example message: "Hello, this is Tax Advocate Group. Your case has an
          update. Please call us at 1-800-517-1807. Reply STOP to opt out of SMS
          messaging."
        </p>

        <h3>3. Message Frequency</h3>
        <p>
          Message frequency may vary depending on the type of communication.
          During your initial inquiry period, you may receive up to five (5) SMS
          messages related to your tax matter, consultation scheduling, and case
          evaluation. Following enrollment as an active client, you may receive
          no more than one (1) SMS message per calendar month for purposes
          including document request notifications, scheduled payment reminders,
          and case status updates.
        </p>

        <h3>4. Potential Fees for SMS Messaging</h3>
        <p>
          Standard message and data rates may apply depending on your carrier's
          pricing plan. These fees may vary if the message is sent domestically
          or internationally. Tax Advocate Group is not responsible for any
          charges imposed by your mobile carrier.
        </p>

        <h3>5. Opt-In Method</h3>
        <p>
          You may opt in to receive SMS messages from Tax Advocate Group in the
          following way:
        </p>
        <ul>
          <li>
            By checking the SMS consent checkbox on any of our online forms.
          </li>
        </ul>
        <p>
          The SMS consent checkbox is separate from other consent types and is
          entirely optional. Opting in to receive SMS messages is not a
          condition of purchase or service.
        </p>

        <h3>6. Opt-Out Method</h3>
        <p>
          You can opt out of receiving SMS messages at any time by replying{" "}
          <strong>STOP</strong> to any SMS message you receive from Tax Advocate
          Group. Alternatively, you can contact us directly at{" "}
          <a href="mailto:inquiry@taxadvocategroup.com">
            inquiry@taxadvocategroup.com
          </a>{" "}
          to request removal from our messaging list. After opting out, you will
          receive a one-time confirmation message.
        </p>

        <h3>7. Help</h3>
        <p>
          If you are experiencing any issues with SMS communications, reply with
          the keyword <strong>HELP</strong> to any message, or contact us
          directly:
        </p>
        <ul>
          <li>
            Phone: <a href="tel:18005171807">1-800-517-1807</a>
          </li>
          <li>
            Email:{" "}
            <a href="mailto:inquiry@taxadvocategroup.com">
              inquiry@taxadvocategroup.com
            </a>
          </li>
        </ul>
        <p>
          If you do not wish to receive SMS messages, simply do not check the
          SMS consent box on our forms.
        </p>

        <h3>8. Standard Messaging Disclosures</h3>
        <ul>
          <li>Message and data rates may apply.</li>
          <li>
            You can opt out at any time by texting <strong>STOP</strong>.
          </li>
          <li>
            For assistance, text <strong>HELP</strong> or visit our{" "}
            <Link to="/privacy-policy">Privacy Policy</Link> and{" "}
            <Link to="/terms-of-service">Terms of Service</Link> pages.
          </li>
          <li>Message frequency may vary.</li>
        </ul>

        <h2>Contact Information</h2>
        <p>
          <strong>Tax Advocate Group</strong>
          <br />
          21625 Prairie Street, Suite #200
          <br />
          Chatsworth, CA 91311, United States
        </p>
        <p>© Tax Advocate Group. All Rights Reserved.</p>
      </div>
    </div>
  );
};

export default TermsOfService;
